<template>
  <customer-view-template>
    <div v-if="usu_email" class="protocolos">
      <h1>{{ $t('protocolos.titulo') }}</h1>
        <div class="dass-filters">          
          <q-input
            outlined
            v-model="filterText"
            :label="$t('dass.filterProtocols')"
            style="min-width: 280px"
            @input="filterProtocols"
          > 
            <template v-slot:prepend>
              <q-icon name="search" />
            </template>
            <template v-if="filterText"  v-slot:append>
              <q-icon                               
                name="cancel"
                @click="filterText = ''"
                style="cursor: pointer;"
              />
            </template>
          </q-input>
          <q-select
            outlined
            v-model="situationFilter"
            :options="situations"
            style="min-width: 280px"
            :label="$t('protocolo.status')"
            @input="filterProtocols"
          >
            <template v-slot:prepend>
              <q-icon name="search" />
            </template>            
          </q-select>
        </div>
      <div
        v-if="
          !isLoading &&
          protocols.length > 0 &&          
          protocols[0].hasOwnProperty('PRT_ID')
        "
      >
        <div
          class="protocol"
          v-for="protocol in protocolsFilters"
          v-bind:key="protocol.PRT_ID"
        >
          <div class="action">
            <router-link
              :to="`/protocol/${protocol.PRT_ID}`"
              :title="$t('dass.visualizarDetalhes')"
            >
              <dass-icon
                token="icon-action-visibility"
                size="25"
                color="var(--color-secondary--blue__light)"
              >
              </dass-icon>
            </router-link>
          </div>
          <router-link
            :to="`/protocol/${protocol.PRT_ID}`"
            :title="$t('dass.visualizarDetalhes')"
          >
            <h3 :class="`color-sit-${protocol.SIT_ID}`">
              {{ protocol.PRT_ID }} -
              <span>
                {{ $t(`situacoes.${protocol.SIT_ID}`) }}
              </span>
            </h3>
          </router-link>

          <div class="detalhe">
            <b>{{ $t('etapas.produto.numeroNF') }}:</b
            ><span> {{ protocol.PRT_NFISCAL }}</span>
          </div>
          <div class="detalhe">
            <b>{{ $t('protocolos.dataAbertura') }}:</b>
            <span>
              {{ $filters.toDateBRL(protocol.PRT_DTCRIACAO) }} -
              {{ $filters.toHourBRL(protocol.PRT_DTCRIACAO, false, 'America/Sao_Paulo') }}
            </span>
          </div>
        </div>
      </div>      
      <div v-else-if="isLoading" class="loading-state">        
        <p>{{ $t('dass.loadingProtocols') }}</p>
      </div>
      <div v-else-if="!isLoading && protocols.length === 0" class="empty-state">
        {{ $t('erro.noProtocols') }}
      </div>
    </div>
    <div v-else class="empty-state">{{ $t('erro.noProtocols') }}</div>
  </customer-view-template>
</template>
<script>
import CustomerViewTemplate from '../components/templates/CustomerView'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Protocols',
  components: { CustomerViewTemplate },
  methods: {
    ...mapActions('protocols', ['loadProtocols']),
    ...mapActions('toasts', ['showToast']),   
    async initialize() {
      if (!this.usu_email && !this.phone) return
      try {
        this.isLoading = true
        await this.loadProtocols()
        this.isLoading = false
      } catch (error) {
        this.showToast({
          variant: 'error',
          message: error
        })        
      }
    }
  },
  data() {
    return {
      situationFilter: '',
      filterText: '',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('protocols', { protocols: 'getProtocols' }),
    ...mapGetters('session', {
      usu_email: 'getUsuEmail',
      phone: 'getUsuPhone'
    }),   
    situations() {
      const situacoes = [
        {
          value: null,
          label: this.$t('dass.all')
        }
      ]
      this.protocols.forEach(protocol => {
        if (!situacoes.find(situacao => situacao.value === protocol.SIT_ID)) {
          situacoes.push({
            value: protocol.SIT_ID,
            label: protocol.SIT_NOME
          })
        }
      })
      return situacoes
    },
    protocolsFilters() {      
      const filterText = this.filterText.toLowerCase()
      
      return this.protocols.filter(protocol => {
        let isValid = true
        if (this.situationFilter?.value && protocol?.SIT_ID !== this.situationFilter?.value) {
          isValid = false
        }
        if (filterText && !(
          String(protocol?.PRT_ID)?.toLowerCase().includes(filterText) ||
          String(protocol?.PRT_NFISCAL)?.toLowerCase().includes(filterText) ||
          protocol?.PEDIDO_ORIGINAL?.toLowerCase().includes(filterText)
        )) {
          isValid = false
        }
        return isValid
      })
    }
  },
  created: function () {    
    this.initialize()
  },  
}
</script>

<style lang="scss">
.protocolos {
  text-align: left;
  .dass-filters {
    display: flex;
    justify-content: flex-end;
    gap: var(--space);
    margin-bottom: var(--space__1-5x);
  }
  h3 {
    margin: 0;
    margin-bottom: var(--space__0-5x);
    width: 100%;
  }
  > div {
    display: flex;
    flex-wrap: wrap;
  }
  .protocol {
    width: 24%;
    padding: var(--space__0-75x);
    border: 1px solid var(--color-neutral__30);
    border-radius: var(--border-radius-md);
    display: flex;
    flex-wrap: wrap;
    margin-bottom: var(--space);
    margin-right: var(--space);
    position: relative;
    @media (min-width: 576px) {
      min-width: 450px;
    }
    @media (max-width: 576px) {
      width: 100%;
      margin-right: 0;
    }
    .action {
      position: absolute;
      right: var(--space__0-25x);
      top: var(--space__0-25x);
    }
    .detalhe {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      > b {
        min-width: 35%;
        text-align: right;
        margin-right: var(--space__0-5x);
        @media (max-width: 576px) {
          min-width: 45%;
        }
      }
    }
  }  
}

.loading-state,
.empty-state {
  display: flex;
  align-items: start;
  justify-content: center;
  padding: var(--space__3x);
  min-height: 300px;
  text-align: center;
  
  p {
    margin-top: var(--space);
    color: var(--theme-gray);
    font-size: 16px;
  }
}

.empty-state {
  color: var(--theme-gray);
  font-size: 16px;
}
</style>